import { useQuery } from "@/api/swr/useQuery";
import { regularAssessmentSchema } from "@/schema/console/regular-assessments/RegularAssessment";
import { z } from "zod";

export function useGetRegularAssessments() {
  return useQuery(
    z.array(regularAssessmentSchema),
    "/console/assessment_papers?is_premium=true",
  );
}
